// This file is used to provide cover access methods to build settings that may be migrated in the
// future.
import { ENABLE_MASTERCARD_ANIMATION, CLEAR_SAF_DECLINES } from '../constants'

export const enableMasterCardAnimation = () => {
  return ENABLE_MASTERCARD_ANIMATION === true || ENABLE_MASTERCARD_ANIMATION === 'true'
}

export const enableClearSafDeclines = () => {
  return CLEAR_SAF_DECLINES === true || CLEAR_SAF_DECLINES === 'true'
}
